import {DtoTechnologyTranslationRequestInterface, DtoTechnologyTranslationResponseInterface} from "../interfaces";
import {TechnologyTranslationModel} from "../interfaces/models/technology/technology-translation.model";

export const mapTechnologyTranslationFromDto = (dto: DtoTechnologyTranslationResponseInterface): TechnologyTranslationModel => {
  return {
    language: dto.language,
    technologyName: dto.technologyName,
    changedBy: dto.changedBy,
    changedTimestamp: dto.changedTimestamp
  };
};

export const mapTechnologyTranslationFromDtoArray = (
  array: Array<DtoTechnologyTranslationResponseInterface>
): Array<TechnologyTranslationModel> => {
  const result: Array<TechnologyTranslationModel> = [];

  array.forEach(dto => {
    result.push(mapTechnologyTranslationFromDto(dto));
  });

  return result;
};

export const mapTechnologyTranslationToDto = (model: TechnologyTranslationModel): DtoTechnologyTranslationRequestInterface => {
  return {
    language: model.language,
    technologyName: model.technologyName
  };
};

export const mapTechnologyTranslationToDtoArray = (
  array: Array<TechnologyTranslationModel>
): Array<DtoTechnologyTranslationRequestInterface> => {
  const result: Array<DtoTechnologyTranslationRequestInterface> = [];

  array.forEach(model => {
    result.push(mapTechnologyTranslationToDto(model));
  });

  return result;
};
